import { useFeatureFlagsQuery } from "@/hooks/useFeatureFlagsQuery";

/**
 * Whether the Messaging feature is enabled. Reads the runtime `messagesEnabled` feature flag
 * (GET /settings/features). Defaults OFF while the query is loading or on error, so messaging
 * UI stays hidden until the flag is explicitly switched on — the client does not want it live
 * on day 1. Toggle it in Dev Tools → Tools & Scripts → Feature Flags.
 */
export function useMessagesEnabled(): boolean {
  const { data } = useFeatureFlagsQuery();
  return data?.messagesEnabled ?? false;
}
